import { IValueObject } from '../../core/domain/interfaces';

export class ValueObject<T> implements IValueObject<T> {
  public readonly result: T;
  protected constructor(private readonly payload: T) {
    this.result = payload;
  }

  public static create<T>(payload: T): ValueObject<T> {
    return new ValueObject<T>(payload);
  }
}
